import { render, staticRenderFns } from "./NlDropdownItem.vue?vue&type=template&id=fb94ffda&scoped=true&"
import script from "./NlDropdownItem.vue?vue&type=script&lang=js&"
export * from "./NlDropdownItem.vue?vue&type=script&lang=js&"
import style0 from "./NlDropdownItem.vue?vue&type=style&index=0&id=fb94ffda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb94ffda",
  null
  
)

export default component.exports